// Mock data for Uncle Willie's Southern Bistro
// NOTE: This is FRONTEND MOCK data. Swap with a backend later.

export const RESTAURANT = {
  name: "Uncle Willie's",
  tagline: "Southern Bistro",
  phone: "(904) 677-9924",
  phoneHref: "tel:+19046779924",
  address: "3000 Dunn Ave, Suite 62",
  city: "Jacksonville, FL 32218",
  hours: "Tue–Sat 11 AM–8 PM · Sun 11 AM–6 PM · Closed Mondays",
  service: "Dine-in · Pickup · Delivery",
  directions:
    "https://www.google.com/maps/dir/?api=1&destination=3000%20Dunn%20Ave%2C%20Suite%2062%2C%20Jacksonville%2C%20FL%2032218",
  eyebrow: "Since way back · Dunn Ave, Jax",
  priceRange: "$10–20 per person",
};

export const HERO = {
  heading: "Uncle Willie's",
  script: "Southern Bistro",
  accent: "all for you!",
  blurb:
    "Fried chicken, cornmeal catfish, oxtails cooked all day, and sides your grandma would nod at. Cooked slow. Served warm. On Dunn Avenue.",
  plate: {
    img: "/images/07ygfciq_12287.jpg",
    no: "№ 001",
    label: "The Oxtail Dinner",
    status: "Hot & ready",
  },
  side1: {
    img: "/images/kdz898ws_12289.jpg",
    label: "The Soul Food Plate",
  },
  side2: {
    img: "/images/kr1wzk6k_12293.jpg",
    label: "Fried Chicken & Fixin's",
  },
  ticker: [
    "$10–20 per person",
    "Pickup & Delivery",
    "Tue–Sat 11 AM–8 PM (Sun til 6)",
    "Cornbread + 2 sides included",
  ],
};

export const CAKES = {
  eyebrow: "— something sweet —",
  title: "We Customize",
  titleAccent: "Cakes",
  blurb:
    "Birthdays, weddings, anniversaries, or just because — we bake custom cakes to order, fresh from our kitchen with the same love we put into every plate. Tell us the occasion and we'll make it sweet.",
  footnote: "fresh · custom · baked with love",
  video: { id: "CFHlKVl0gb0", label: "Watch Us Bake" },
  video2: { id: "lv08qItNI_I", label: "Fresh From the Oven" },
  items: [
    {
      no: "№ 01",
      img: "/images/ancq0ksp_14886.webp",
      caption: "50 Golden Years",
    },
    {
      no: "№ 02",
      img: "/images/pp5fkt42_14888.webp",
      caption: "Dusty Blue Florals",
    },
    {
      no: "№ 03",
      img: "/images/fwkamfra_14890.webp",
      caption: "Lavender & Rose",
    },
    {
      no: "№ 04",
      img: "/images/es24rmto_14892.webp",
      caption: "Gold & Blush",
    },
    {
      no: "№ 05",
      img: "/images/bttgxw89_14894.webp",
      caption: "Baby in Bloom",
    },
    {
      no: "№ 06",
      img: "/images/btflerna_14896.webp",
      caption: "Pink Princess Cupcakes",
    },
    {
      no: "№ 07",
      img: "/images/tmbqi9hk_14898.webp",
      caption: "Bridal Cupcake Dress",
    },
    {
      no: "№ 08",
      img: "/images/0svyw6x9_14922.webp",
      caption: "Cascading Gold Roses",
    },
    {
      no: "№ 09",
      img: "/images/uqdks7qe_14916.webp",
      caption: "Diamond Wedding Tiers",
    },
    {
      no: "№ 10",
      img: "/images/hmh5eakd_14914.webp",
      caption: "Grand Tiered Celebration",
    },
  ],
};

export const MARQUEE_WORDS = [  "Quality",
  "Presentation",
  "Flavor",
  "★ All for you ★",
  "Fried Chicken",
  "Catfish",
  "Oxtails",
  "Collards",
  "Mac & Cheese",
  "Cornbread",
  "★ Dunn Ave, Jax ★",
];

export const REELS = {
  eyebrow: "— holiday sweets —",
  title: "Uncle Willie's Sweet Creations",
  blurb: "A little Christmas magic from our kitchen. Tap any clip to play — sound on!",
  videos: [
    { id: "hm0BIejuAAI", label: "Festive Holiday Bakes" },
    { id: "-dF8vbb3iQ0", label: "Merry Christmas Cakes" },
    { id: "4ajcyiWTIew", label: "Uncle Willie's\nSweet Treats" },
  ],
};

export const MENU = {
  eyebrow: "— today's board —",
  title: "The Menu",
  blurb:
    "All meals come with 2 sides, rice & cornbread or a dinner roll. Ask about today's specials — they change with what came in fresh.",
  sections: [
    {
      no: "Section 01 · Specials",
      badge: "1 year anniversary",
      title: "Anniversary Specials",
      note: "Celebrating one year in Jacksonville — thank you for your support!",
      type: "priced",
      items: [
        { name: "Southern Birthday Dinner", desc: "Your choice of entrée, 2 sides, rice and cornbread", price: "$17.99" },
        { name: "Dinner for Two", desc: "Your choice of two entrées, 4 sides, rice and cornbread", price: "$33.99" },
        { name: "6 Whole Wings & Fries", desc: "Choice of flavor: Lemon Pepper, Honey BBQ or Teriyaki", price: "$12.99" },
        { name: "Kid's Birthday Meal", desc: "2 chicken tenders, fries, drink and small dessert", price: "$7.99" },
        { name: "Free Birthday Cake Slice", desc: "With the purchase of a complete dinner. While supplies last.", price: "FREE" },
      ],
    },
    {
      no: "Section 02 · Entrées",
      badge: "served hot",
      title: "Entrées",
      note: "Includes 2 sides, rice & cornbread.",
      type: "priced",
      items: [
        { name: "Baked Turkey Wings (1 pc)", price: "$18.99" },
        { name: "Baked Turkey Wings (2 pc)", price: "$24.99" },
        { name: "Fried Chicken (2 pc dark)", price: "$16.99" },
        { name: "Fried Chicken (3 pc dark/white)", price: "$20.99" },
        { name: "Smothered Pork Chops (1 pc)", price: "$16.99" },
        { name: "Smothered Pork Chops (2 pc)", price: "$21.99" },
        { name: "Meatloaf", price: "$16.99" },
        { name: "Liver & Onions", price: "$16.99" },
        { name: "Neck Bones", price: "$16.99" },
        { name: "Fried Whiting", price: "$16.99" },
        { name: "Fried Catfish", price: "$20.99" },
        { name: "Fried Tilapia", price: "$16.99" },
        { name: "BBQ Ribs", price: "$20.99" },
        { name: "Pot Roast", price: "$20.99" },
        { name: "BBQ Pig Feet", price: "$16.99" },
        { name: "Chitlins", price: "$29.99" },
        { name: "Oxtails", price: "$32.99" },
      ],
    },
    {
      no: "Section 03 · Wings",
      badge: "crispy & saucy",
      title: "Wings Combos",
      note: "Flavors: Lemon Pepper, Honey BBQ or Teriyaki.",
      type: "priced",
      items: [
        { name: "6 pc Wings + Fries", price: "$13.99" },
        { name: "10 pc Wings + Fries", price: "$17.99" },
      ],
    },
    {
      no: "Section 04 · Brunch",
      badge: "11 AM – 3 PM",
      title: "Brunch",
      note: "Served 11 AM to 3 PM.",
      type: "priced",
      items: [
        { name: "Shrimp & Grits", desc: "8 shrimp", price: "$13.99" },
        { name: "Fish & Grits", price: "$12.99" },
      ],
    },
    {
      no: "Section 05 · Sides",
      badge: "$6.00 (8 oz.) each",
      title: "Homemade Sides",
      note: "Pick two with every entrée — extra sides $6.00 each (8 oz.).",
      type: "list",
      items: [
        "Macaroni & Cheese",
        "Collard Greens",
        "Candied Yams",
        "Cabbage",
        "Green Beans",
        "Lima Beans",
        "Black-Eyed Peas",
        "Okra & Tomatoes",
        "Potato Salad",
      ],
    },
    {
      no: "Section 06 · Sweet",
      badge: "$6.00 per slice",
      title: "Desserts",
      note: "Homemade daily. $6.00 per slice.",
      type: "priced",
      items: [
        { name: "Red Velvet Cake", price: "$6.00" },
        { name: "Peach Cobbler", price: "$6.00" },
        { name: "Banana Pudding", price: "$6.00" },
        { name: "Pound Cake", price: "$6.00" },
        { name: "Sweet Potato Pie", price: "$6.00" },
        { name: "Anniversary Cake", price: "$6.00" },
      ],
    },
  ],
};

export const STORY = {
  eyebrow: "our story",
  title: "Where Every Meal Feels Like Home.",
  img: "/images/t5r0bn7a_UNCLE_WILLIES.png",
  paragraphs: [
    "Uncle Willie's Southern Bistro was founded with one simple mission: to serve authentic Southern comfort food made with love, passion, and the same recipes that have brought families together for generations.",
    "Founded in 2021 in Atlanta, Georgia, Uncle Willie's began as a dream of Dr. Willie James Swain II — a retired educator, community leader, and lifelong entrepreneur. After decades inspiring students and families through education, Dr. Swain pursued another passion: bringing people together through great food.",
    "Growing up in the South, Dr. Swain learned that the kitchen was more than a place to cook — it was where family gathered, stories were shared, and lasting memories were made. Those values became the foundation of Uncle Willie's.",
    "Today, every meal is prepared with the same commitment to quality, generous portions, and genuine hospitality that inspired the restaurant from the beginning. Good Food. Good Friends. A Good Time.",
  ],
  quote: "The service was good and the atmosphere was welcoming.",
  quoteBy: "— Google Reviews · Verified guest",
  stats: [
    { k: "Est.", v: "Dunn Ave" },
    { k: "Style", v: "Southern Soul" },
    { k: "Method", v: "Slow & Low" },
  ],
};

export const GALLERY = {
  eyebrow: "— the spread —",
  title: "Straight From the Kitchen",
  blurb: "A peek at the plates. Tap any photo to take a closer look.",
  video: { id: "Ru_FaJF3VbU", label: "Straight From Our Kitchen" },
  images: [
    { src: "/images/uklldsxl_12287.jpg", label: "Oxtails & Rice" },
    { src: "/images/a6wnte2f_12289.jpg", label: "The Soul Food Plate" },
    { src: "/images/wvgrwxyf_12291.jpg", label: "Smothered Pork Chops" },
    { src: "/images/x4p6oeds_12293.jpg", label: "Fried Chicken & Fixin's" },
    { src: "/images/keywb0nl_14710.webp", label: "The Family Feast" },
    { src: "/images/tulakfxu_14712.webp", label: "The Sunday Spread" },
  ],
};
